import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { IconButton, Tooltip } from "@mui/material";

import { useDialog } from "../../../../../common/components/dialog/useDialog";
import { useGetLazyPaginatedSKUs } from "../hooks/useGetLazyPaginatedSKUs";
import { ISKUDeviceData, ISKUForm } from "../variables/skuData";
import CreateSKUDialog from "./CreateSKUDialog";

interface EditSKUContainerProps {
  row: {
    id?: string;
    skuNumber?: string;
    configurationName?: string;
    skuDataConfigurations?: string;
  };
}

const EditSKUContainer = ({ row }: EditSKUContainerProps): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();
  const { data } = useGetLazyPaginatedSKUs();

  // Exclude the current row's name so the user can save without renaming.
  const existingConfigurationNames =
    data?.getSKUs?.items
      .filter(item => item?.id !== row.id)
      .map(item => item?.configurationName)
      .filter((name): name is string => Boolean(name)) ?? [];

  let parsedData: ISKUDeviceData[] = [];

  try {
    parsedData = JSON.parse(row.skuDataConfigurations ?? "[]");
  } catch {
    parsedData = [];
  }

  const initialValues: ISKUForm = {
    skuNumber: row.skuNumber ?? "",
    configurationName: row.configurationName ?? "",
    password: parsedData[0]?.password ?? "",
    hasRecordVideo: parsedData[0]?.hasRecordVideo ?? true,
    skuDataConfigurations: parsedData,
  };

  return (
    <>
      <Tooltip title="Edit this template">
        <IconButton size="small" onClick={handleDialogOpen}>
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {open && (
        <CreateSKUDialog
          open={open}
          handleClose={handleDialogClose}
          mode="edit"
          id={row.id}
          initialValues={initialValues}
          existingConfigurationNames={existingConfigurationNames}
        />
      )}
    </>
  );
};

export default EditSKUContainer;
